import "./Lists.css";

export function UL({
  children,
  symbol,
}: {
  children: React.ReactElement[];
  symbol?: string;
}) {
  return <ul className={symbol}>{children}</ul>;
}

export function OL({ children }: { children: React.ReactElement[] }) {
  return <ol>{children}</ol>;
}

export function LI({ children }: { children: string }) {
  return <li>{children}</li>;
}
